import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { type FC } from 'react';

import { ROUTER_NETWORK_HISTORY_DAYS, type RouterNetworkResponse } from '@okvc/schema';

import RouterNetworkCharts from './RouterNetworkCharts.js';
import RouterSimCards from './RouterSimCards.js';

interface RouterOverviewTabProps {
  routerId: string;
  network: RouterNetworkResponse;
  days: number;
  onDaysChange: (days: number) => void;
  canSwitchSim: boolean;
}

const RouterOverviewTab: FC<RouterOverviewTabProps> = ({ routerId, network, days, onDaysChange, canSwitchSim }) => (
  <Stack spacing={2}>
    {network.sims.length === 0 ? (
      <Typography color="text.secondary">No SIMs are configured for this router yet.</Typography>
    ) : (
      <RouterSimCards routerId={routerId} network={network} days={days} canSwitchSim={canSwitchSim} />
    )}
    <Stack direction="row" justifyContent="flex-end">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={days}
        onChange={(_, value: number | null) => value && onDaysChange(value)}
      >
        {ROUTER_NETWORK_HISTORY_DAYS.map((option) => (
          <ToggleButton key={option} value={option}>{`${option} days`}</ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
    <RouterNetworkCharts days={network.days} sims={network.sims} />
  </Stack>
);

export default RouterOverviewTab;
